import { API, getFromLocalStorageByKey, INextError, nextClient } from '@vfit/shared/data-access';
import { useQuery, useQueryClient } from 'react-query';
import { errorMock, IGetMobileAddonResponse } from '@vfit/consumer/data-access';
import { IGetAddonResponse } from './getAddon.models';

const getAddonMobileService = (cartItemId: string, cartId): Promise<IGetAddonResponse> =>
  nextClient.get(`${API.MOBILE_OFFERING_CONFIGURATION}/${cartItemId}`, {
    searchParams: {
      salesChannel: 'selfService',
      context: `shoppingCart.Id==${cartId}`,
      configurationType: 'fullBasicForCatalog',
      qualificationCriteria: 'orderingActivity==newSubscription',
      levelOfData:
        'bundledAddOnConfiguration,bundledAddOnGroupConfiguration,planConfiguration,price,simConfiguration,oldSimConfiguration,mobileOfferingConfiguration',
      portInIndicator: false,
    },
  });

export const useGetAddonsMobile = (queryEnabler = false) => {
  const queryClient = useQueryClient();
  return useQuery(
    ['getAvailableAddonsMobile'],
    () => {
      const shoppingCart = getFromLocalStorageByKey('shoppingCart');
      const cartId: string = shoppingCart?.id || '';
      const cartItem = shoppingCart?.cartItem?.[0];
      const cartItemId: string = cartItem?.id;
      return getAddonMobileService(cartItemId, cartId);
    },
    {
      enabled: queryEnabler,
      onSuccess: (data: IGetMobileAddonResponse) => {
        queryClient.setQueryData('getAvailableAddonsMobile', data);
      },
      onError: (error: INextError) => {
        queryClient.setQueryData(
          'getAvailableAddonsMobile',
          errorMock('getAvailableAddonsMobile', error)
        );
      },
    }
  );
};

